import React from 'react';
import { AlertCircle } from 'lucide-react';
const SUBCATEGORIES = [{
  name: 'Centralized Delivery Mailboxes & Kiosks',
  href: '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-kiosks.html'
}, {
  name: 'Private Delivery Mailboxes',
  href: '/6m8/commercial-mailboxes-lockers/private-delivery-mailboxes.html'
}, {
  name: 'Parcel Lockers',
  href: '/6m8/commercial-mailboxes-lockers/parcel-lockers.html'
}, {
  name: 'Mail Slots, Letter & Book Drops',
  href: '/6m8/commercial-mailboxes-lockers/mail-slots-letter-book-drops.html'
}, {
  name: 'Collection Boxes',
  href: '/6m8/commercial-mailboxes-lockers/collection-boxes.html'
}, {
  name: 'Key Keepers & Key Blanks',
  href: '/6m8/commercial-mailboxes-lockers/key-keepers-key-blanks.html'
}, {
  name: 'Replacement Commercial Locks, Hinges & Doors',
  href: '/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html'
}];
export function BuyingGuidance() {
  return <div className="py-12 bg-white border-b border-brand-border" data-id="element-8">
      <div className="max-w-7xl mx-auto px-4" data-id="element-9">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-8" data-id="element-10">
          <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-11">
            Choose by delivery setup
          </h2>

          <div className="flex items-start gap-3 bg-brand-cream p-4 rounded-lg border border-brand-border/50 max-w-md" data-id="element-12">
            <AlertCircle className="text-brand-gold shrink-0 mt-0.5" size={20} data-id="element-13" />
            <p className="text-sm text-gray-700 leading-snug" data-id="element-14">
              <strong data-id="element-15">Compliance Note:</strong> USPS/project requirements vary
              by product and installation type. Confirm requirements before
              placing commercial orders.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-16">
          {SUBCATEGORIES.map(sub => <a key={sub.name} href={sub.href} className="group bg-brand-cream rounded-lg border border-brand-border p-4 text-center hover:border-brand-green/50 hover:bg-white transition-all flex items-center justify-center min-h-[80px] shadow-sm hover:shadow" data-id="element-17">
              <h3 className="font-medium text-brand-charcoal text-sm group-hover:text-brand-green transition-colors leading-snug" data-id="element-18">
                {sub.name}
              </h3>
            </a>)}
        </div>
      </div>
    </div>;
}